/*
 * Roam Kit Configurator — BRIDGE_LAUNCH_PLAN.md §2.5
 *
 * Builds a kit from independent Shopify products, shows a live total, and on
 * "Add system to cart" posts every selected variant in ONE /cart/add.js call.
 * Each line carries a shared _kit_id so cart/checkout group the components as
 * one configured system. No bundle app — pure Cart AJAX API, Path A/B safe.
 *
 * SCAFFOLD: logic complete; prices read from data-price (cents). Cart grouping
 * presentation in cart template is a later Phase 2.5 item.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      try { return Shopify.formatMoney(cents, theme.moneyFormat); } catch (e) {}
    }
    return '$' + amount;
  }

  function kitId() {
    return 'kit-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
  }

  function Configurator(root) {
    this.root = root;
    this.kitLabel = root.getAttribute('data-kit-label') || 'Custom Roam System';
    this.linesEl = root.querySelector('[data-config-lines]');
    this.totalEl = root.querySelector('[data-config-total]');
    this.noteEl = root.querySelector('[data-config-note]');
    this.wiredNoteEl = root.querySelector('[data-wired-note]');
    this.addBtn = root.querySelector('[data-config-add]');
    this.wiredLimit = parseInt(root.getAttribute('data-wired-limit'), 10) || 0;
    this.overWired = false;
    this.bind();
    this.applyPrefill();
    this.recalc();
  }

  // Pre-populate from a ?kit=handle:qty,handle:qty URL param (the recommender's
  // "Fine-tune in the builder" link). Matches options by data-handle.
  Configurator.prototype.applyPrefill = function () {
    var search = window.location.search;
    if (!search || search.indexOf('kit=') === -1) return;
    var raw = '';
    try { raw = new URLSearchParams(search).get('kit') || ''; }
    catch (e) { var m = search.match(/[?&]kit=([^&]*)/); raw = m ? decodeURIComponent(m[1]) : ''; }
    if (!raw) return;
    var want = {};
    raw.split(',').forEach(function (pair) {
      var kv = pair.split(':');
      if (kv[0]) want[kv[0]] = parseInt(kv[1], 10) || 0;
    });
    var opts = this.root.querySelectorAll('[data-config-option][data-handle]');
    for (var i = 0; i < opts.length; i++) {
      var el = opts[i], h = el.getAttribute('data-handle');
      if (!(h in want)) continue;
      var q = want[h];
      if (el.matches('[data-config-quantity]')) {
        var max = parseInt(el.getAttribute('max'), 10) || 99;
        el.value = Math.max(0, Math.min(max, q));
      } else if (el.type === 'checkbox') {
        el.checked = q > 0;
      } else if (el.type === 'radio') {
        if (q > 0) el.checked = true;
      }
    }
  };

  // Total quantity across all options flagged as wired sensors.
  Configurator.prototype.wiredCount = function () {
    var n = 0;
    var els = this.root.querySelectorAll('[data-config-quantity][data-wired="true"]');
    for (var i = 0; i < els.length; i++) n += parseInt(els[i].value, 10) || 0;
    return n;
  };

  Configurator.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('change', function () { self.recalc(); });
    this.root.addEventListener('input', function (e) {
      if (e.target.matches('[data-config-quantity]')) self.recalc();
    });
    this.root.addEventListener('click', function (e) {
      var step = e.target.getAttribute && e.target.getAttribute('data-qty-step');
      if (step) {
        var input = e.target.parentNode.querySelector('[data-config-quantity]');
        if (input) {
          var next = (parseInt(input.value, 10) || 0) + parseInt(step, 10);
          var max = parseInt(input.getAttribute('max'), 10) || 99;
          input.value = Math.max(0, Math.min(max, next));
          self.recalc();
        }
      }
    });
    if (this.addBtn) {
      this.addBtn.addEventListener('click', function () { self.addToCart(); });
    }
  };

  // Returns [{id, quantity, role, title}]
  Configurator.prototype.selection = function () {
    var items = [];
    var opts = this.root.querySelectorAll('[data-config-option]');
    for (var i = 0; i < opts.length; i++) {
      var el = opts[i];
      if (el.matches('[data-config-quantity]')) {
        var qty = parseInt(el.value, 10) || 0;
        if (qty > 0) {
          items.push({
            id: el.getAttribute('data-variant-id'),
            quantity: qty,
            price: parseInt(el.getAttribute('data-price'), 10) || 0,
            role: el.getAttribute('data-role'),
            title: el.getAttribute('data-title')
          });
        }
      } else if ((el.type === 'radio' || el.type === 'checkbox') && el.checked) {
        items.push({
          id: el.value,
          quantity: 1,
          price: parseInt(el.getAttribute('data-price'), 10) || 0,
          role: el.getAttribute('data-role'),
          title: el.getAttribute('data-title')
        });
      }
    }
    return items;
  };

  Configurator.prototype.recalc = function () {
    var items = this.selection();
    var total = 0;
    var html = '';
    for (var i = 0; i < items.length; i++) {
      total += items[i].price * items[i].quantity;
      html += '<li><span>' + (items[i].role || items[i].title) +
        (items[i].quantity > 1 ? ' ×' + items[i].quantity : '') +
        '</span><span>' + formatMoney(items[i].price * items[i].quantity) + '</span></li>';
    }
    if (this.linesEl) this.linesEl.innerHTML = html || '<li class="roam-configurator__empty">No options selected yet.</li>';
    if (this.totalEl) this.totalEl.textContent = formatMoney(total);
    this.checkWired();
  };

  // Enforce the hard wired-sensor cap (hub cable inputs). Mix-and-match
  // allowed up to the limit; over-select shows a clear message + blocks add.
  Configurator.prototype.checkWired = function () {
    if (!this.wiredLimit) return;
    var n = this.wiredCount();
    this.overWired = n > this.wiredLimit;
    var atLimit = n >= this.wiredLimit;

    // Prevent the mistake: disable the "+" on every wired row once the
    // cable-input cap is reached (decrement stays active so they can swap).
    var wired = this.root.querySelectorAll('[data-config-quantity][data-wired="true"]');
    for (var i = 0; i < wired.length; i++) {
      var plus = wired[i].parentNode.querySelector('[data-qty-step="1"]');
      if (plus) {
        plus.disabled = atLimit;
        plus.setAttribute('aria-disabled', atLimit ? 'true' : 'false');
      }
    }

    if (this.wiredNoteEl) {
      if (this.overWired) {
        this.wiredNoteEl.hidden = false;
        this.wiredNoteEl.className = 'roam-configurator__wired-note is-error';
        this.wiredNoteEl.textContent =
          "You've selected " + n + " wired sensors — the Roam Hub supports " +
          this.wiredLimit + ". Remove " + (n - this.wiredLimit) + " to continue.";
      } else if (atLimit) {
        this.wiredNoteEl.hidden = false;
        this.wiredNoteEl.className = 'roam-configurator__wired-note';
        this.wiredNoteEl.textContent =
          "Max wired sensors selected (" + this.wiredLimit + " of " + this.wiredLimit +
          "). Float, shore power and battery/bilge share " + this.wiredLimit +
          " cable inputs — remove one to swap. Want to monitor more? Add wireless " +
          "sensors to expand your system — no cable input needed.";
      } else {
        this.wiredNoteEl.hidden = true;
        this.wiredNoteEl.className = 'roam-configurator__wired-note';
        this.wiredNoteEl.textContent = '';
      }
    }
    if (this.addBtn) {
      this.addBtn.disabled = this.overWired;
      this.addBtn.setAttribute('aria-disabled', this.overWired ? 'true' : 'false');
    }
  };

  Configurator.prototype.note = function (msg, isError) {
    if (!this.noteEl) return;
    this.noteEl.hidden = !msg;
    this.noteEl.textContent = msg || '';
    this.noteEl.classList.toggle('is-error', !!isError);
  };

  Configurator.prototype.addToCart = function () {
    var self = this;
    if (this.overWired) {
      this.note('Too many wired sensors selected — reduce to ' + this.wiredLimit + ' to continue.', true);
      return;
    }
    var items = this.selection();
    if (!items.length) { this.note('Select at least one option to build your system.', true); return; }

    var kid = kitId();
    var payload = {
      items: items.map(function (it) {
        return {
          id: Number(it.id),
          quantity: it.quantity,
          properties: {
            _kit_id: kid,
            _kit: self.kitLabel,
            'System role': it.role || it.title
          }
        };
      })
    };

    this.addBtn.disabled = true;
    this.note('Adding your system to the cart…');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Add to cart failed'); });
        return r.json();
      })
      .then(function () {
        self.note('');
        document.dispatchEvent(new CustomEvent('roam:kit-added', { detail: { kitId: kid, items: items } }));
        window.location.href = '/cart';
      })
      .catch(function (err) {
        self.note(err.message || 'Something went wrong. Please try again.', true);
        self.addBtn.disabled = false;
      });
  };

  function init() {
    var roots = document.querySelectorAll('[data-roam-configurator]');
    for (var i = 0; i < roots.length; i++) new Configurator(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
